import Vue from 'vue'
import VueRouter from 'vue-router'
import main from '@/views/main'
import main2 from '@/views/main2'
import signup from '@/views/signup'
import preRegistration from '@/views/pre-registration'
import feed from '@/views/feed'
import login from '@/views/login'
import firstLogin from '@/views/first-login'
import forgotPassword from '@/views/forgot-password'
import setNewPassword from '@/views/set-new-password'
import cookieDeclaration from '@/views/cookie-declaration'
import termsOfUse from '@/views/terms-of-use'
import privacyPolicy from '@/views/privacy-policy'
import onlineTraining from '@/views/online-training'
import {checkNextIsTraining, fetchMyUser, getIsAuthenticatedQuery, isRefreshTokenSet, refreshTokenOrFail} from '@/scripts/auth-utils'
import profileSettings from '@/views/profile-settings'
import faq from '@/views/faq'
import exhibitionPhoto from '@/views/exhibition-photo'
import exhibitionPhotos from '@/views/exhibition-photos'
import {hostname, resetStore, store} from '@/scripts/globals'
import {logout} from '@/scripts/auth-utils'
import {apolloClient} from '@/plugins/apollo'
import pricing from '@/views/pricing'
import activate from "@/views/activate.vue";
// eslint-disable-next-line no-unused-vars

Vue.use(VueRouter)

// put "authRequirement: true" to force redirect to login if not authenticated
// put "authRequirement: false" to force redirect to feed if authenticated
// when authRequirement undefined - nothing done just got to path
// authRequirement flag leads to isAuthenticated request before visiting page


const routes = [
    {
        path: '/',
        name: hostname.includes('rowerup') || hostname.includes('localhost')  ? 'main' : 'main2',
        component: hostname.includes('rowerup') || hostname.includes('localhost') ? main : main2,
        meta: {
             // title can be a funtcion of "to" in afterEach; body stuff can be set same way
        }
    },
    {
        path: '/feed',
        name: 'feed',
        component: feed,
        meta: {
            title: 'RowerUp feed',
            authRequirement: true
        }
    },
    {
        path: '/my-videos',
        name: 'my-trainings',
        component: feed,
        meta: {
            title: 'My videos',
            authRequirement: true
        }
    },
    {
        path: '/training-:trainingId-:activeTab/:trainingParams*',
        name: 'training',
        component: feed,
        meta: {
            title: 'Training',
            authRequirement: true
        }
    },
    {
        path: '/online-training',
        name: 'online-training', // change carefully. Other stuff uses this name
        component: onlineTraining,
        meta: {
            title: 'RowerUp real-time analysis',
            authRequirement: true
        }
    },
    {
        path: '/signup-:tag',
        name: 'signup',
        component: signup,
        meta: {
            authRequirement: false,
            title: 'SignUp'
        }
    },
    {
        path: '/pre-registration',
        name: 'pre-registration',
        component: preRegistration,
        meta: {
            authRequirement: false,
            title: 'Pre-registration'
        }
    },
    {
        path: '/set-new-password',
        name: 'set-new-password',
        component: setNewPassword,
        meta: {
            authRequirement: false,
            title: 'Set new password'
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: forgotPassword,
        meta: {
            authRequirement: false,
            title: 'Forgot password'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        meta: {
            authRequirement: false,
            title: 'Login'
        }
    },
    {
        path: '/logout',
        name: 'logout'
    },
    {
        path: '/first-login',
        name: 'first-login',
        component: firstLogin,
        meta: {
            title: 'First login',
            authRequirement: true
        }
    },
    {
        path: '/activate/:token',
        name: 'activate',
        component: activate,
    },
    {
        path: '/profile-settings',
        name: 'profile-settings',
        component: profileSettings,
        meta: {
            title: 'Profile settings',
            authRequirement: true
        }
    },
    {
        path: '/faq',
        name: 'faq',
        component: faq,
        meta: {
            title: 'FAQ',
            userPreload: true
        }
    },
    {
        path: '/terms-of-use',
        name: 'terms-of-use',
        component: termsOfUse,
        meta: {
            title: 'Terms of use',
        },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: privacyPolicy,
        meta: {
            title: 'Privacy policy',
        },
    },
    {
        path: '/cookie-declaration',
        name: 'cookie-declaration',
        component: cookieDeclaration,
        meta: {
            title: 'Cookie declaration',
        },
    },
    {
        path: '/ROWERON-exhibition-photos',
        name: 'exhibition-photos',
        component: exhibitionPhotos,
        meta: {
            title: 'Exhibition photos',
            authRequirement: true
        }
    },
    {
        path: '/ROWERON-exhibition-photo-:thumbnailId',
        name: 'exhibition-photo',
        component: exhibitionPhoto,
        meta: {
            title: 'Exhibition photo',
            authRequirement: true
        }
    },
    {
        path: '*',
        redirect: {name: 'main'}
    },
    {
        path: '/pricing',
        name: 'pricing',
        component: pricing,
        meta: {
            title: 'Pricing',
            userPreload: true
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkExactActiveClass: 'is-active',
    routes
})


router.beforeEach(async (to, from, next) => {
    if (to.name === 'logout')
        await logout()

    if ((to.name === 'main' && (from.name || to.redirectedFrom)) || (from.name === 'main')) {
        window.location.href = to.fullPath
        return
    }

    let requiresAuth = to.matched.some(record => record.meta.authRequirement === true)
    let requiresNoAuth = to.matched.some(record => record.meta.authRequirement === false)
    let requiresUserPreload = to.matched.some(record => record.meta.userPreload === true)

    if (requiresUserPreload) {
        let qRes = await apolloClient.query({query: getIsAuthenticatedQuery()})
        if (!qRes.data['isAuthenticated'] && isRefreshTokenSet()) {
            try {
                await refreshTokenOrFail(apolloClient)
                qRes = await apolloClient.query({query: getIsAuthenticatedQuery()})
            } catch (e) {
                //do not do anything
            }
        }

        if (qRes.data['isAuthenticated']) {
            await fetchMyUser(true);
        }
        next();
        return;
    }

    if (!requiresAuth && !requiresNoAuth) {
        next()
        return
    }

    if (requiresAuth) {
        await fetchMyUser(true)
        if (store.myUser['baseInfoWasSet'])
            if (to.name === 'first-login') {
                next({name: 'feed'})
                return
            } else {
                next()
                return
            }
        else {
            if (to.name === 'first-login') {
                next()
                return
            } else {
                next({name: 'first-login', query: {next: to.path}})
            }
        }
    }
    if (requiresNoAuth) {
        let qRes = await apolloClient.query({query: getIsAuthenticatedQuery()})

        if (qRes.data['isAuthenticated']) {
            next({name: 'feed'})
            return
        } else {
            resetStore()
            next()
        }
        // noinspection UnnecessaryReturnStatementJS
        return
    }
})

// noinspection JSUnusedLocalSymbols
router.afterEach((to,
                  // eslint-disable-next-line
                  from) => {
    Vue.nextTick(() => {
        if (to.meta.title)
            document.title = to.meta.title
        if (to.meta.description)
            document.description = to.meta.description
        if (to.meta.viewport)
            document.viewport = to.meta.viewport
    })
})


export default router

export const menuItems = [
    {
        href: router.resolve({name: 'feed'}).href,
        name: 'Feed',
        icon: 'cilBullhorn'
    },
    {
        href: router.resolve({name: 'profile-settings'}).href,
        name: 'Profile',
        icon: 'cilUser'
    },
    {
        href: router.resolve({name: 'faq'}).href,
        name: 'FAQ',
        icon: 'cilSchool'
    },
    {
        href: router.resolve({name: 'pricing'}).href,
        name: 'Pricing',
        icon: 'cilBasket'
    }

]

export const menuItemsNoAuth = [
    {
        href: '/pricing',
        name: 'Pricing',
        icon: 'cilBasket'
    },
    {
        href: '/#contact',
        name: 'Contact us',
        icon: 'cilEnvelopeOpen'
    },
    {
        href: router.resolve({name: 'signup', params: {tag: 'from-main'}}).href,
        name: 'Sign up', // change carefully. Other stuff uses this name
        icon: 'cilUserFollow'
    },
    {
        href: router.resolve({name: 'login'}).href,
        name: 'Sign in',
        icon: 'cilUser'
    }

]

export const menuItemsNoAuthWMain = [
    {
        href: '/',
        name: 'Main',
        icon: 'cilHome'
    }
].concat(menuItemsNoAuth)


export function swapMenuItemsClosedRegistrationToOpenIfAllowed(menuItems, route) {
    let nextIsTrainingFlag = checkNextIsTraining()
    if (nextIsTrainingFlag) {
        let newMenuItems = JSON.parse(JSON.stringify(menuItems))
        for (let item of newMenuItems) {
            if (item.name === 'Sign up') {
                item.href = router.resolve({name: 'signup', params: {tag: 'by-training'}, query: route.query}).href
            }
        }
        return newMenuItems
    } else
        return menuItems
}


export function hideFromMenuItemsIfNotAllowed(menuItems) {
    // if (store.showStaffControls || allowOnlineTrainingBetaAccess)
    //     return menuItems
    // else
    //     return menuItems.filter(item => !item.name.startsWith('Real-time analysis (beta)'))
    return menuItems
}
